export const winnerRoles = ['Winner', 'Finalist', 'Both', 'Undesignated'] as const;

export type WinnerRole = typeof winnerRoles[number];

export type AwardedNominationRole = Exclude<WinnerRole, 'Undesignated'>;
